module.exports = __webpack_public_path__ + "img/KPMG.6a64cb56.png";